// ── Collateral math (pure) — extracted from App.js ──
// Used by CollateralSpreadsheet and CollateralTab.

export const calcCollateralLine = (line) => {
    const gross      = parseFloat(line.grossamount      || 0);
    const ineligible = parseFloat(line.ineligibleamount || 0);
    const rate       = parseFloat(line.advancerate      || 0);
    const reserves   = parseFloat(line.otherreserves    || 0);
    const sublimit   = parseFloat(line.sublimit         || 0);

    const eligible        = gross - ineligible;
    const valuepredilution = eligible * (rate / 100);
    const netvalue         = valuepredilution - reserves;
    const collateralvalue  = sublimit > 0 ? Math.min(netvalue, sublimit) : netvalue;

    // AR aging total
    const totalaraging = (parseFloat(line.araging0to30   || 0)) +
                        (parseFloat(line.araging31to60  || 0)) +
                        (parseFloat(line.araging61to90  || 0)) +
                        (parseFloat(line.araging90plus  || 0)) +
                        (parseFloat(line.araging120plus || 0));

    // Inventory breakout total
    const totalinventory = (parseFloat(line.invrawmaterials   || 0)) +
                          (parseFloat(line.invworkinprogress || 0)) +
                          (parseFloat(line.invfinishedgoods  || 0)) +
                          (parseFloat(line.invgeneral        || 0)) +
                          (parseFloat(line.invother          || 0));

    return { eligible, valuepredilution, collateralvalue, totalaraging, totalinventory };
  };

export const calcCollateralHeader = (header, lines) => {
    // Total Available Inventory = sum of collateralvalue for Inventory lines
    const inventoryLines = lines.filter(l => l.collateraltype === 'Inventory');
    const totalAvailableInventory = inventoryLines.reduce((s, l) => {
      return s + calcCollateralLine(l).collateralvalue;
    }, 0);

    // Net Available Inventory
    const sublimit  = parseFloat(header.aggregateinventorysublimit || 0);
    const invReserve = parseFloat(header.aggregateinventoryreserve || 0);
    const cappedInv  = sublimit > 0 ? Math.min(totalAvailableInventory, sublimit) : totalAvailableInventory;
    const netAvailableInventory = cappedInv - invReserve;

    // Total Collateral Value = sum all line collateral values - totalAvailableInventory + netAvailableInventory
    const sumAllLines = lines.reduce((s, l) => s + calcCollateralLine(l).collateralvalue, 0);
    const totalCollateralValue = sumAllLines - totalAvailableInventory + netAvailableInventory;

    // Total AP Aging
    const totalAPAging = (parseFloat(header.apaging0to30  || 0)) +
                        (parseFloat(header.apaging31to60 || 0)) +
                        (parseFloat(header.apaging61to90 || 0)) +
                        (parseFloat(header.apaging90plus || 0));

    return { totalAvailableInventory, netAvailableInventory, totalCollateralValue, totalAPAging };
  };
